// extracted by mini-css-extract-plugin
module.exports = {"products":"GV","productContainer":"HV","overFlowVisible":"IV","resultsHeading":"JV","oosMessaging":"KV","bestExp":"LV","bestExpRecognized":"MV","bestExpMobile":"NV"};